import React, { Component } from 'react';
import styled from 'styled-components';

class Dropdown extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isListOpen: false
    }
    this.wrapperRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      this.close();
    }
  }

  close = () => {
    if (this.state.isListOpen === true) {
      this.setState({ isListOpen: false }, document.removeEventListener('mousedown', this.handleClickOutside));
    }
  }

  open = () => {
    if (this.state.isListOpen === false) {
      this.setState({ isListOpen: true }, document.addEventListener('mousedown', this.handleClickOutside));
    } else {
      this.close();
    }
  }

  selectItem = (item, id, isActive) => {
    this.props.selected(item, id, isActive);
    this.close();
  }

  render () {
    const { isListOpen } = this.state;
    const { title, list, name, width, height, option, id, funnel_id, isActive } = this.props;

    const WrapDiv = styled.div`
      position: relative;
      & button {
        box-shadow: none;
        text-shadow: none;
        cursor: pointer;
        background-color: #ffffff;
        border-radius: 0px;
        color: #1E2228;
        font-weight: normal;
      }
    `;
    const ToggleButton = styled.button`
      width: 36px;
      height: 36px;
      margin: 0px;
      padding: 0px !important;
      border-radius: 6px !important;
      border: 1px solid #EFEFF0;
      box-sizing: border-box;
      background-color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      & div {
        height: 4px;
        width: 4px;
        border-radius: 4px;
        background-color: #1B49EA;
        margin: 1px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:before, &:after {
          content: '';
          height: 4px;
          width: 4px;
          border-radius: 4px;
          background-color: #1B49EA;
          margin: 1px 4px;
          display: block;
          flex-shrink: 0;
        }
      }
      &:hover {
        background-color: #EDF0FD;
      }
    `;
    const List = styled.div`
      display: flex;
      flex-direction: column;
      position: absolute;
      z-index: 4;
      right: 0px;
      overflow: hidden;
      box-shadow: 0px 6px 24px rgba(0, 0, 0, 0.1);
      border-radius: 10px;
    `;
    const ListItem = styled.button`
      min-width: ${width};
      background-color: #ffffff;
      color: #1E2228;
      font-weight: 400;
      font-size: 12px;
      line-height: 21px;
      border-bottom: 1px solid #E6E6E6;
      padding: 8px 18px !important;
      margin: 0px;
      white-space: nowrap;
      display: flex;
      &:hover {
        background-color: #EDF0FD;
        color: #1B49EA;
      }
    `;
    const ListItemA = styled.a`
      width: ${width};
      background-color: #ffffff;
      color: #1E2228;
      font-weight: 400;
      font-size: 12px;
      line-height: 21px;
      border-bottom: 1px solid #E6E6E6;
      padding: 8px 18px;
      margin: 0px;
      white-space: nowrap;
      display: flex;
      text-decoration: none;
      &:hover {
        background-color: #EDF0FD;
        color: #1B49EA;
      }
    `;

    return (
      <WrapDiv ref={this.wrapperRef}>
        <ToggleButton onClick={this.open} open={isListOpen}>
          <div />
        </ToggleButton>

        { isListOpen && (
          <List>
            { list && list.length > 0 && list.map((item, itemIndex) => (
              item[option] === 'Edit' ?
                <ListItemA href={`/contest-plus/edit/${funnel_id}`} key={`${item[option]}_${itemIndex}`} style={{ minWidth: width }}>{item[option]}</ListItemA>
              :
                item[option] === 'View' ?
                  <ListItemA target="_blank" href={`/contest-plus/details/${id}`} key={`${item[option]}_${itemIndex}`} style={{ minWidth: width }}>{item[option]}</ListItemA>
                :
                  <ListItem
                    key={`${item[option]}_${itemIndex}`}
                    onClick={() => this.selectItem(item[option], id, isActive)}
                    style={{ minWidth: width }}
                  >
                    { item[option] === 'Draft/Publish' ?
                      isActive ? 'Draft' : 'Publish'
                    :
                      item[option]
                    }
                  </ListItem>
            ))}
          </List>
        )}
      </WrapDiv>
    );
  }
}

export default Dropdown;